var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMethodusicon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 54,
    viewBox: "0 0 94 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6468 54L0 28.2638L4.92326 23.3234L25.6468 44.1191L30.57 49.0596L25.6468 54ZM45.1108 54L19.4641 28.2638L24.3873 23.3234L45.1108 44.1191L89.0767 0L94 4.94043L45.1108 54ZM45.1108 34.4681L40.1876 29.5277L69.6127 0L74.5359 4.94043L45.1108 34.4681Z",
    fill: "#9E2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethodusicon2);
export default __webpack_public_path__ + "static/media/methodusicon2.71728a8def658c9459925ce1ff216c3b.svg";
export { ForwardRef as ReactComponent };